export default __webpack_public_path__ + "static/media/x33mall-banner-cn.b78162b0.jpg";